import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import LogoMark from "@/components/LogoMark";
import { LayoutDashboard, FolderOpen, Calendar, MessageSquare, LogOut, ArrowLeft } from "lucide-react";

const links = [
    { to: "/admin", end: true, label: "Overview", icon: LayoutDashboard },
    { to: "/admin/requests", label: "Case Requests", icon: FolderOpen },
    { to: "/admin/bookings", label: "Bookings", icon: Calendar },
    { to: "/admin/messages", label: "Messages", icon: MessageSquare },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const nav = useNavigate();
    return (
        <div className="min-h-screen bg-ink-900 text-white flex" data-testid="admin-layout">
            <aside className="w-72 hidden md:flex flex-col border-r border-white/10 bg-ink-900 p-6 gap-2 md:sticky md:top-0 md:self-start md:h-screen md:overflow-y-auto">
                <LogoMark size={44} />
                <div className="mt-8 text-xs uppercase tracking-[0.2em] text-white/40">Admin Console</div>
                <div className="text-sm text-gold-500 mt-1 mb-6">{user?.email}</div>
                {links.map((l) => (
                    <NavLink
                        key={l.to}
                        to={l.to}
                        end={l.end}
                        data-testid={`admin-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                                isActive ? "bg-gold-500/10 text-gold-500 border border-gold-500/30" : "text-white/70 hover:bg-white/5 border border-transparent"
                            }`
                        }
                    >
                        <l.icon size={18} /><span className="text-sm font-medium">{l.label}</span>
                    </NavLink>
                ))}
                <div className="mt-auto space-y-2 pt-6 border-t border-white/10">
                    <button onClick={() => nav("/")} className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-white/60 hover:bg-white/5">
                        <ArrowLeft size={16} /><span className="text-sm">Back to site</span>
                    </button>
                    <button onClick={async () => { await logout(); nav("/"); }} data-testid="admin-logout-btn" className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-400 hover:bg-red-500/10">
                        <LogOut size={16} /><span className="text-sm">Sign out</span>
                    </button>
                </div>
            </aside>
            <main className="flex-1 bg-ink-800 min-w-0">
                <div className="p-6 md:p-10"><Outlet /></div>
            </main>
        </div>
    );
}
